module.exports = __webpack_public_path__ + "static/media/banner.e32b5c74.png";